var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container",attrs:{"fluid":""}},[_c('v-data-table',{staticClass:"elevation-3 row-pointer",attrs:{"headers":this.headers,"items":this.data,"item-key":"Effet","sort-by":this.options.sortBy,"sort-desc":this.options.sortDesc,"footer-props":{
      showFirstLastPage: true,
      itemsPerPageOptions: [20, 50, 100],
    }},scopedSlots:_vm._u([{key:"item.dueDateBrut",fn:function(ref){
    var item = ref.item;
return [_c('v-col',[_vm._v(_vm._s(item.dueDate))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }